import type { ReactNode } from 'react';
import type { DataTableCellPin } from './dataTableCell.js';
import styles from './DataTable.module.css';
import { cx } from '../../utils/cx.js';

export function wrapStickyCellContent(
  node: ReactNode,
  pin: DataTableCellPin,
  opts?: { ellipsis?: boolean },
): ReactNode {
  if (pin !== 'start') return node;
  const ellipsis = opts?.ellipsis !== false;
  return (
    <div className={cx(styles.cellStickyMain, !ellipsis && styles.cellStickyMainNoEllipsis)}>
      {node}
    </div>
  );
}
